'use client';
import GameContext from '~/client/components/Game/context/Game/GameContext';
import useNewGameContextProvider from './useGameContextProvider/useNewGameContextProvider';

type Props = {
  game: SingleGameFragment;
  gameDescription?: GameDescriptionFragment;
  gameSession?: GameSessionFragment;
};

const NewGameContextProvider: FC<Props> = ({
  game,
  gameDescription,
  gameSession,
  children,
}) => {
  const { value } = useNewGameContextProvider({
    game,
    gameSession,
    gameDescription,
  });
  return <GameContext.Provider value={value}>{children}</GameContext.Provider>;
};

export default NewGameContextProvider;
